import {gql,TypedDocumentNode} from '@apollo/client';

export type Package = {
    code: string,
    createdAt: Date,
    description: string,
    id: string,
    lastUpdatedBy: string,
    price: number,
    title: string,
    updatedAt: Date,
}

interface Result {
    allPackages: Package[]
}

interface Variables {
    limit: number,
    offset: number,
}

export const GET_PACKAGES: TypedDocumentNode<Result, Variables> = gql`
    query GetPackages{
        allPackages {
            code
            createdAt
            description
            id
            lastUpdatedBy
            price
            title
            updatedAt
        }
    }       
`
